import styled, { css, CSSProperties } from 'styled-components';

export const TableHeaderCellText = styled.div`
  ${({}) => css`
    display: flex;
    align-items: center;
    padding: 0 5px;
  `}
`;

export const Container = styled.div`
  ${({}) => css`
    overflow-x: auto;
    overflow-y: auto;
    border-radius: 10px;
  `}
`;

export const Table = styled.table`
  ${({}) => css`
    text-align: left;
    border-spacing: 0;
    width: 100%;
  `}
`;
export const Header = styled.thead`
  ${({}) => css`
    background: rgb(239, 239, 239);
    color: #364856;
    position: sticky;
    top: 0;
    z-index: 5;
  `}
`;

export const CellHead = styled.th<FixedColumn>`
  ${({ fontSize = 20, isFixed, fixedPosition, left }) => css`
    display: flex;
    position: sticky;
    font-size: ${fontSize}px;
    ${isFixed &&
    fixedPosition === 'left' &&
    css`
      left: ${left ?? '0px'};
      z-index: 3;
      background: rgb(239, 239, 239);
    `}
  `}
`;

export const Body = styled.tbody`
  ${({}) => css`
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  `}
`;

export const LineHead = styled.tr<any>`
  ${({ $gridTemplateColumns }) => css`
    display: grid;
    grid-template-columns: ${$gridTemplateColumns};
    min-height: 50px;
  `}
`;

export const Line = styled.tr<{
  $isSelected?: boolean;
  $gridTemplateColumns?: string;
  hover?: boolean;
}>`
  ${({ $isSelected, $gridTemplateColumns, hover = false }) => css`
    position: relative;
    display: grid;
    grid-template-columns: ${$gridTemplateColumns};
    background: ${$isSelected ? '#eee' : '#fff'};
    cursor: pointer;
    min-height: 40px;
    ${hover &&
    css`
      background: #eee;
    `}
    &::before {
      position: absolute;
      content: '';
      min-width: calc(100% - 30px);
      max-width: calc(100% - 30px);
      left: 15px;
      min-height: 1px;
      background: #cecece;
      top: calc(100% - 1px);
      z-index: 4;
    }
  `}
`;

interface FixedColumn {
  fontSize?: number;
  isFixed?: boolean;
  fixedPosition?: 'left' | 'right';
  left?: CSSProperties['left'];
  hover?: boolean;
  isSelected?: boolean;
  background?: CSSProperties['background'];
  locked?: boolean;
  color?: CSSProperties['color'];
}

export const Cell = styled.td<FixedColumn>`
  ${({
    fontSize = 20,
    isFixed,
    left,
    fixedPosition,
    hover = false,
    isSelected = false,
    background,
    locked = false,
    color = 'black',
  }) => css`
    display: flex;
    align-items: center;
    height: 100%;
    color: ${!locked
      ? color
      : css`color-mix(in srgb, ${color} 40%, #ffffff 60%)`};
    font-size: ${fontSize}px;
    margin: auto 0;
    padding: 0 5px;
    background: white;
    ${isFixed &&
    css`
      position: sticky;
      ${fixedPosition === 'left'
        ? css`
            left: ${left ?? '0px'};
          `
        : css`
            right: 0px;
          `}
      z-index: 3;
      min-height: 100%;
    `}
    background: ${hover || isSelected
      ? locked
        ? css`color-mix(in srgb, color-mix(in srgb, ${background} 40%, #ffffff 60%) 90%, #000000 10%)`
        : css`color-mix(in srgb, ${background} 90%, #000000 10%)`
      : locked
        ? css`color-mix(in srgb, ${background} 40%, #ffffff 60%)`
        : background};
  `}
`;

export const FilterContainer = styled.div<{ active?: boolean }>`
  ${({ active = false }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 5px;
    padding: 3px;
    background: ${active ? 'rgba(255, 255, 255, 0.3)' : 'none'};
    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  `}
`;

export const TableControlContainer = styled.div`
  ${({}) => css`
    display: flex;
    font-size: 20px;
    margin-top: 1rem;
    align-items: center;
    justify-content: end;
    margin-right: 20px;
    gap: 20px;
  `}
`;

export const TableControlPageInputContainer = styled.div`
  ${({}) => css`
    display: flex;
  `}
`;

export const TableControlArrowsContainer = styled.div`
  ${({}) => css`
    display: flex;
    align-items: center;
    background: white;
    border-radius: 8px;
    justify-content: center;
    padding: 4px;
  `}
`;

export const BoxChild = styled.div`
  display: flex;
  background: #efefef;
  padding: 3px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  width: 100%;
`;

export const BoxTextControl = styled.div`
  display: flex;
  font-size: 12px;
  padding-right: 10px;
  background: '#EFEFEF';
  color: #364856;
`;

export const TableControlDisplayContainer = styled.div`
  ${({}) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    user-select: none;
    min-width: 200px;
  `}
`;

export const TableControlArrowsIconContainer = styled.button<{
  active?: boolean;
}>`
  ${({ active = true }) => css`
    display: flex;
    justify-content: start;
    align-items: center;
    background: white;
    border-radius: 10px;
    padding: 7px;
    cursor: ${active ? '#pointer' : 'default'};
    border: none;
    &:hover {
      background: ${active ? '#eeeeee' : 'none'};
    }
    &:active {
      background: ${active ? '#d9d9d9' : 'none'};
    }
  `}
`;

export const TableControlPageInput = styled.div`
  ${({}) => css`
    display: flex;
    width: 110px;
  `}
`;

export const TableControlPageInputLabel = styled.div`
  ${({}) => css`
    display: flex;
    align-items: center;
    margin-right: 0.7rem;
  `}
`;

export const SubTableContainer = styled.div<{
  show?: boolean;
  height: number;
}>`
  ${({ show, height }) => css`
    transition: height 0.5s;
    height: ${show ? height : 0}px;
    overflow: hidden;
  `}
`;

export const ReportLine = styled.tr<{ bottom: number }>`
  ${({ bottom = 0 }) => css`
    background: white;
    position: sticky;
    height: 40px;
    z-index: 4;
    display: flex;
    bottom: ${bottom}px;
    justify-content: space-between;
    padding: 0 15px;
    &::before {
      position: absolute;
      content: '';
      min-width: calc(100% - 30px);
      max-width: calc(100% - 30px);
      left: 15px;
      min-height: 1px;
      background: #cecece;
      top: calc(100% - 1px);
      z-index: 4;
    }
  `}
`;

export const LeftReportCell = styled.td<{ color?: CSSProperties['color'] }>`
  ${({ color = 'black' }) => css`
    position: sticky;
    display: flex;
    left: 15px;
    align-items: center;
    font-weight: bold;
    color: ${color};
  `}
`;

export const RightReportCell = styled.td<{ color?: CSSProperties['color'] }>`
  ${({ color = 'black' }) => css`
    position: sticky;
    display: flex;
    right: 15px;
    align-items: center;
    font-weight: bold;
    color: ${color};
  `}
`;

export const NotFoundImage = styled.img`
  position: absolute;
  height: calc(100vh - 350px);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); 
`;
